export var ADMINISTRATOR = 'administrator';
export var DEVELOPER = 'developer';
export var ANALYST = 'analyst';
export var READ_ONLY = 'readOnly';
export var AccessRoles;
(function (AccessRoles) {
    AccessRoles["ADMINISTRATOR"] = "administrator";
    AccessRoles["DEVELOPER"] = "developer";
    AccessRoles["ANALYST"] = "analyst";
    AccessRoles["READ_ONLY"] = "readOnly";
})(AccessRoles || (AccessRoles = {}));
//# sourceMappingURL=AccessLevel.js.map